const master = JSON.parse(document.getElementById('apolloState').textContent)

export default master